import Counter from './components/Counter';
import './App.css';

function App() {
  return (
    <div >
      
        <Counter />
      
    </div>
  );
}

export default App;
